import { Pipe, PipeTransform, inject } from '@angular/core';
import { FileService } from '../services/file.service';

@Pipe({
  name: 'resourceUrl',
  standalone: true,
})
export class ResourceUrlPipe implements PipeTransform {
  private fileService = inject(FileService);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}
  transform(value?: string) {
    if (!value) {
      return '';
    }
    return this.fileService.getResourcesUrl(value);
  }
}
